<template>
  <auth-layout>
    <div class="card-header justify-content-center">
      <h4 class="card-title">{{ $t("auth.signuptitle") }}</h4>
    </div>
    <div class="card-body" v-if="!token">
      <ValidationObserver v-slot="{ passes }" tag="div">
        <form
          @submit.prevent="passes(formSubmit)"
          class="needs-validation mb-3"
          novalidate=""
        >
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="username"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.username") }}</label>
            <input
              type="text"
              class="form-control error"
              name="username"
              v-model="username"
              placeholder="Non-numbers above 6 digits"
              aria-placeholder="Non-numbers above 6 digits"
              aria-invalid="true"
            />
            <!-- <label class="error" for="email">{{ errors[0] }}</label> -->
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <ValidationProvider
            rules="required|email"
            v-slot="{ errors }"
            name="method"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.email") }}</label>
            <input
              type="email"
              class="form-control error"
              placeholder="example:service.otc919@outlook.com "
              name="email"
              v-model="email"
              aria-invalid="true"
            />
            <!-- <label class="error" for="email">{{ errors[0] }}</label> -->
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="method"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.mobile") }}</label>
            <input
              type="text"
              class="form-control error"
              placeholder="example:16688776 "
              name="mobile"
              v-model="mobile"
              aria-invalid="true"
            />
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <ValidationProvider
            rules="passwordFieldName|verify_password"
            v-slot="{ errors }"
            name="password"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.password") }}</label>
            <input
              type="password"
              class="form-control error"
              :placeholder="$t('auth.password')"
              name="password"
              v-model="password"
              aria-invalid="true"
            />
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="realName"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.realName") }}</label>
            <input
              type="text"
              class="form-control error"
              :placeholder="$t('auth.realNameDesc')"
              name="realName"
              v-model="realName"
              aria-invalid="true"
            />
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="idCode"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.idCode") }}</label>
            <input
              type="text"
              class="form-control error"
              :placeholder="$t('auth.idCodeDesc')"
              name="idCode"
              v-model="idCode"
              aria-invalid="true"
            />
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="inviteCode"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.inviteCode") }}</label>
            <input
              type="text"
              class="form-control error"
              :placeholder="$t('auth.inviteCode')"
              name="inviteCode"
              v-model="inviteCode"
              aria-invalid="true"
            />
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
          <div class="invitation-highlight">
            <span class="new-icon">NEW</span> 好友邀請，系統不定期發放邀請獎勵
          </div>
          <div class="invitation-highlight">
            <span class="new-icon">NEW</span> 電報工會頻道最新平台動態<a
              href="https://t.me/otc919"
              target="blank"
              >加入频道</a
            >
          </div>
          <div class="text-center mt-4">
            <vue-recaptcha
              sitekey="6Ldc4LUbAAAAAGG8zVVNiPJvXWpJXMln7vD4-J1r"
              v-model="recaptcha"
            >
              <!-- recaptchaHost="www.recaptcha.net" -->

              <button type="submit" class="btn btn-success btn-block w-100">
                {{ $t("auth.reg") }}
              </button>
              <!-- <button>Click me</button> -->
            </vue-recaptcha>
            <!-- <button type="submit" class="btn btn-success btn-block">
              {{ $t("auth.login") }}
            </button> -->
          </div>
        </form>
      </ValidationObserver>

      <!-- <div class="new-account mt-3">
        <p>
          {{ $t("auth.hasaccount") }}

          <router-link
            class="text-primary"
            :to="dark ? 'signin-dark' : 'signin'"
            >{{ $t("auth.login") }}</router-link
          >
        </p>
      </div> -->
    </div>

    <div class="card-body" v-if="token">
      <div class="page-back text-muted" @click="token = ''">
        <span><i class="fa fa-angle-left"></i></span> Back
      </div>
      <h3 class="text-center">{{ codeType }} Verification</h3>
      <p class="text-center mb-5">We will send one time code on this number</p>
      <form @submit.prevent="codeSubmit">
        <div class="form-group">
          <label>Your {{ codeType }} Code</label>
          <input
            type="text"
            v-model="valicode"
            class="form-control text-center font-weight-bold"
            value=""
          />
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-success btn-block">
            Verify
          </button>
        </div>
      </form>
      <div class="info mt-3">
        <p class="text-muted">
          You dont recommended to save password to browsers!
        </p>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import { regV2S1, regV2SE } from "../../plugins/api/user";
import VueRecaptcha from "vue-recaptcha";
import AuthLayout from "../../components/layouts/AuthLayout";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    AuthLayout,
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha,
  },
  data() {
    return {
      username: "",
      email: "",
      password: "",
      mobile: "",
      inviteCode: "1HaJgME4C",
      realName: "",
      idCode: "",
      checkbox: "",
      recaptcha: "",
      dark: window.location.pathname.includes("dark"),
      token: "",
      valicode: "",
      codeType: "",
    };
  },
  methods: {
    formSubmit() {
      // console.log(this.recaptcha);
      regV2S1({
        username: this.username,
        email: this.email,
        mobile: this.mobile,
        password: this.password,
        inviteCode: this.inviteCode,
        realName: this.realName,
        idCode: this.idCode,
        checkbox: this.checkbox,
      }).then((res) => {
        // console.log(res.code);
        if (res && res.data && res.data.token) {
          this.token = res.data.token;
          this.codeType = res.data.codeType;
        } else {
          this.$Message.warning(res.msg);
          this.$alert(res.msg, "Pros", {
            confirmButtonText: "Enter",
            callback: (action) => {},
          });
        }
      });
      // console.log(window.recaptcha)
      return;
      // this.$router.push("/signup-validate");
    },
    codeSubmit() {
      regV2SE({
        token: this.token,
        code: this.valicode,
      }).then((res) => {
        if (res.code == 0) {
          this.$alert(
            "Registration is successful, click Enter to log in",
            "prompt",
            {
              confirmButtonText: "Enter",
              callback: (action) => {
                // this.$router.push(`/signin?email=${this.email}`);
                window.location.href = `https://trade-web.otc919.com/?email=${this.email}`;
              },
            }
          );
        }
      });
    },
  },
};
</script>
<style scoped>
.invitation-highlight {
  padding: 10px 10px;
  background-color: #ffcc00; /* 黄色背景 */
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin: 10px 0;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* 简单的阴影 */
}

.new-icon {
  display: inline-block;
  background-color: red; /* 红色背景 */
  color: white; /* 文字颜色 */
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 8px;
  margin-right: 4px;
  vertical-align: middle;
}
</style>